import { useState, type FormEvent } from 'react';
import { Button } from '@shared/ui/Button';
import { Modal } from '@shared/ui/Modal';
import {
  Form,
  Row,
  FormGroup,
  Label,
  Input,
  Select,
  ModalFormFooter,
} from './styled';

interface CreateAdvanceRetentionModalProps {
  open: boolean;
  onClose: () => void;
  onCreateAdv: (data: {
    direction: string;
    counterpartyName: string;
    contractNumber: string;
    projectName: string;
    initialAmount: number;
    expectedCloseDate?: string;
  }) => Promise<void>;
  isCreating: boolean;
}

export function CreateAdvanceRetentionModal({
  open,
  onClose,
  onCreateAdv,
  isCreating,
}: CreateAdvanceRetentionModalProps) {
  const [advDirection, setAdvDirection] = useState('payable_advance');
  const [advCpName, setAdvCpName] = useState('');
  const [advContract, setAdvContract] = useState('');
  const [advProject, setAdvProject] = useState('');
  const [advAmount, setAdvAmount] = useState('');
  const [advDueDate, setAdvDueDate] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const amt = Number(advAmount);
    if (!advCpName.trim() || !amt || amt <= 0) return;

    await onCreateAdv({
      direction: advDirection,
      counterpartyName: advCpName.trim(),
      contractNumber: advContract.trim() || 'Без номера',
      projectName: advProject.trim() || 'Общий',
      initialAmount: amt,
      expectedCloseDate: advDueDate || undefined,
    });
    setAdvCpName('');
    setAdvAmount('');
    setAdvContract('');
    setAdvProject('');
    setAdvDueDate('');
  };

  return (
    <Modal
      open={open}
      title="Новая запись об авансе или гарантийном удержании"
      onClose={onClose}
    >
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>Направление операции</Label>
          <Select value={advDirection} onChange={(e) => setAdvDirection(e.target.value)}>
            <option value="payable_advance">Аванс выданный (подрядчикам/поставщикам)</option>
            <option value="receivable_advance">Аванс полученный (от Заказчика)</option>
            <option value="receivable_retention">Гарантийное удержание Заказчика к возврату</option>
            <option value="payable_retention">Гарантийное удержание с субподрядчика</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Контрагент *</Label>
          <Input
            placeholder="ООО СтройСнаб"
            value={advCpName}
            onChange={(e) => setAdvCpName(e.target.value)}
            required
          />
        </FormGroup>

        <Row>
          <FormGroup>
            <Label>Объект строительства</Label>
            <Input
              placeholder="ПС 110 кВ Заполярная"
              value={advProject}
              onChange={(e) => setAdvProject(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Номер договора</Label>
            <Input
              placeholder="2026/СМР-14"
              value={advContract}
              onChange={(e) => setAdvContract(e.target.value)}
            />
          </FormGroup>
        </Row>

        <Row>
          <FormGroup>
            <Label>Сумма, ₽ *</Label>
            <Input
              type="number"
              placeholder="2500000"
              value={advAmount}
              onChange={(e) => setAdvAmount(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Ожидаемый срок закрытия</Label>
            <Input
              type="date"
              value={advDueDate}
              onChange={(e) => setAdvDueDate(e.target.value)}
            />
          </FormGroup>
        </Row>

        <ModalFormFooter>
          <Button $variant="secondary" type="button" onClick={onClose}>
            Отмена
          </Button>
          <Button $variant="primary" type="submit" disabled={isCreating}>
            {isCreating ? 'Сохранение…' : 'Добавить'}
          </Button>
        </ModalFormFooter>
      </Form>
    </Modal>
  );
}
